import {del as deleteFetch, post as postFetch,} from '../utils'
import get from './get'
import {isNullOrUndefined} from "util";
import getMetadata from "./getMetadata";
import getById from "./getById";
import getElementById from "./getElementById"
import {homePathGenerator, slugify} from "../authentication/utils";

const makeItemForm = ({
  active,
  title,
  subtitle,
  link,
  image,
  video,
  newTab,
  preview,
  embedUrl,
  translations,
  sectionId,
}, usePUTMethod) => {
  const form = new FormData()
  form.append('active', active ? 1 : 0)
  form.append('new_tab', newTab ? 1 :0)
  if (title) form.append('title', title)
  if (subtitle) form.append('subtitle', subtitle)
  if (!isNullOrUndefined(link)) form.append('link', link)
  if (image) form.append('image', image, image.name)
  if (video) form.append('videoId', video)
  if (preview) form.append('previewId', preview)
  if (sectionId) form.append('section_id', sectionId)
  form.append('embed_url', embedUrl || '')
  if (translations) {
    form.append('translations', JSON.stringify(translations))
  }
  if (usePUTMethod) form.append('_method', 'put')
  return form
}

const makeElementForm = ({
  titleEn,
  titleEs,
  type,
  columns,
  dataSource,
  order,
  includeGold,
  rowsToShow,
  onlyImage,
  contentCreatorType,
  selectedTags,
  unselectedTags,
  selectedContentCreatorTypes,
  link,
  isCreating,
  shape,
  fixedTitle,
  withBackground,
  numbered,
  navbarViewType,
  parent,
  featuredType,
  playlist,
  sectionId,
  section,
}, usePUTMethod) => {
  const form = new FormData()
  if (!isNullOrUndefined(titleEs)) form.append('translations[es][title]', titleEs)
  if (!isNullOrUndefined(titleEn)) form.append('translations[en][title]', titleEn)
  if (type) form.append('type', type)
  if (columns) form.append('columns', columns)
  if (rowsToShow) form.append('rows_to_show', rowsToShow)
  if (dataSource) form.append('data_source', dataSource === 'section' ? 'link' : dataSource)
  if (!isNullOrUndefined(link)) form.append('link', link)
  if (!isNullOrUndefined(onlyImage)) form.append('only_image', onlyImage ? 1 : 0)
  if (order) form.append('order', order)
  form.append('include_gold', includeGold ? 1 : 0)
  if (usePUTMethod) form.append('_method', 'put')
  if (contentCreatorType) form.append('content_creator_type', contentCreatorType)
  if (selectedTags && selectedTags.length > 0) selectedTags.forEach(x => form.append("tags_ids[]", x));
  if (unselectedTags && unselectedTags.length > 0) unselectedTags.forEach(x => form.append("not_tags_ids[]", x));
  if (selectedContentCreatorTypes && selectedContentCreatorTypes.length > 0) selectedContentCreatorTypes.forEach(x => form.append("content_creator_type_ids[]", x.value));
  if (isCreating) form.append('creating', isCreating ? 1 : 0)
  if (shape) form.append('shape', shape)
  if (!isNullOrUndefined(fixedTitle)) form.append('fixed_title', fixedTitle ? 1 : 0)
  if (!isNullOrUndefined(withBackground)) form.append('with_background', withBackground ? 1 : 0)
  if (!isNullOrUndefined(numbered)) form.append('numbered', numbered ? 1 : 0)
  if (navbarViewType) form.append('view_type', navbarViewType)
  if (parent) form.append('parent', parent.id)
  if (shape == 'x1') {
    form.append('editorial', 1)
    form.append('inverted', 0)
  } else if (featuredType) {
    form.append('inverted', featuredType == 'inverted' && !numbered ?  1 : 0)
    form.append('editorial', featuredType == 'editorial' && !numbered ?  1 : 0)
  } 
  if (playlist) form.append('playlist_id', playlist)
  if (sectionId) form.append('section_id', sectionId)
  if (section) form.append('link', window.location.protocol + '//' + window.location.host + (section.main ? homePathGenerator('') : `/home/${section.value}-${slugify(section.label).replace('-', '')}`))

  return form
}

const makeElementFormOrder = (orderData) => {
  const form = new FormData()
  if (orderData.length > 0) {
    orderData.forEach((homeElement,index) => {
      form.append(`home_elements[${index}][id]`, homeElement.id);
      form.append(`home_elements[${index}][order]`, homeElement.order);
    })
  }
  form.append('_method', 'put')

  return form
}

const createBannerItem = (host) => (elementId, data, onProgress) => postFetch(`${host}/home/elements/${elementId}/items`, makeItemForm(data), {}, onProgress)

const deleteBannerItem = (host) => (elementId, itemId) => deleteFetch(`${host}/home/elements/${elementId}/items/${itemId}`)

const updateBannerItem = (host) => (elementId, itemId, data, onProgress) => postFetch(`${host}/home/elements/${elementId}/items/${itemId}`, makeItemForm(data, true), {}, onProgress)

const del = (host) => (elementId) => deleteFetch(`${host}/home/elements/${elementId}`)

const create = (host) => (data) => postFetch(`${host}/home/elements`, makeElementForm(data))
  .then(response => response.json())

const update = (host) => (elementId, data) => postFetch(`${host}/home/elements/${elementId}`, makeElementForm(data, true))
  .then(response => response.json())

const updateOrder = (host) => (order) => postFetch(`${host}/home/elements/order`, makeElementFormOrder(order))

const test = (host) => (data) => postFetch(`${host}/home/elements/test`, makeElementForm(data)).then(response => response.json())

export default host => ({
  get: get(host),
  getById: getById(host),
  createBannerItem: createBannerItem(host),
  deleteBannerItem: deleteBannerItem(host),
  updateBannerItem: updateBannerItem(host),
  delete: del(host),
  create: create(host),
  update: update(host),
  updateOrder: updateOrder(host),
  test: test(host),
  getMetadata: getMetadata(host),
  getElementById: getElementById(host),
})
